document.addEventListener("alpine:init", () => {
    Alpine.data("postGrid", () => ({
        showMoreFilters: false,
        more_filters: [],
        isLoading: false,
        currentFilters: {
            search: "",
        },
        postGrid: null,
        filterPrefix: {
            taxonomy: "filter-t-",
            meta: "filter-m-",
            search: "",
        },
        searchValue: null,
        searchForm: null,
        debounceTimer: null,
        showMoreFilters: false,
        showDropdowns: {},
        openFilters: false,
        panelOpenIndex: 0,
        selectedFilter: null,

        init() {
            this.postGrid = this.$el;
            this.currentFilters = this.getCurrentFilters();
            this.searchForm = this.$refs.searchContainer;
            this.panelOpenIndex = 0;

            if (this.searchForm) {
                this.eventListeners();
            }
        },

        isPanelOpen(index) {
            return this.panelOpenIndex === index;
        },

        toggleAccordion(index) {
            this.panelOpenIndex = this.panelOpenIndex === index ? -1 : index;
        },

        toggleDropdown(taxonomy) {
            if (typeof this.showDropdowns[taxonomy] === "undefined") {
                this.showDropdowns[taxonomy] = true;
            } else {
                this.showDropdowns[taxonomy] = !this.showDropdowns[taxonomy];
            }
        },

        eventListeners() {
            this.searchForm.addEventListener("submit", (e) => {
                e.preventDefault();
                if (this.$refs.searchField.value.length) {
                    this.currentFilters.search = this.$refs.searchField.value;
                }

                clearTimeout(this.debounceTimer);

                this.debounceTimer = setTimeout(() => {
                    this.toggleFilters();
                    this.toggleMultipleFilters();
                    pegasus.scroll(this.postGrid);
                }, 300);
            });
        },

        hasActiveFilters() {
            return Object.keys(this.currentFilters).length > 0;
        },

        toggleFilters(term = "", filterName = "", type = "taxonomy") {
            const filter = this.getPrefixedFilter(filterName, type);

            // If this is the first filter to be added, just add it.
            if (typeof this.currentFilters[filter] === "undefined") {
                this.currentFilters[filter] = term;

                // Refresh the post grid content
                this.fetchContent();
                return;
            }

            // If we have filters for the current filter, check if the term is already in the list.
            if (this.currentFilters[filter].length) {
                if (this.currentFilters[filter].includes(term)) {
                    // If the term is already in the list, remove it from the filter.
                    this.currentFilters[filter] = this.removeFilter(filter, term);
                    // If this filter filter is now empty, remove it from the current filters.
                    if (!this.currentFilters[filter].length) {
                        delete this.currentFilters[filter];
                    }
                } else {
                    // If the term is not already in the list, add it.
                    this.currentFilters[filter] += "," + term;
                }
            } else {
                // If there isn't a filter for this filter, add it and then add the term to it.
                this.currentFilters[filter] = term;
            }

            // Refresh the post grid content
            if (fetch) {
                this.fetchContent();
            }
        },

        toggleMultipleFilters(term = "", filterName = "", type = "taxonomy") {
            const filter = this.getPrefixedFilter(filterName, type);

            if (typeof this.currentFilters[filter] === "undefined") {
                this.currentFilters[filter] = [term];
                this.fetchContent();
                return;
            }

            if (Array.isArray(this.currentFilters[filter])) {
                if (this.currentFilters[filter].includes(term)) {
                    this.currentFilters[filter] = this.removeFilter(
                        filter,
                        term
                    );
                    if (!this.currentFilters[filter].length) {
                        delete this.currentFilters[filter];
                    }
                } else {
                    this.currentFilters[filter].push(term);
                }
            }

            this.fetchContent();
        },

        removeFilter(filter, value) {
            const filterValue = this.currentFilters[filter];
            const filterValueArray = filterValue.split(",");

            for (let i = 0; i < filterValueArray.length; i++) {
                if (filterValueArray[i] === value) {
                    filterValueArray.splice(i, 1);
                }
            }

            return filterValueArray.toString();
        },

        clearFilters() {
            const currentUrl = window.location.href;

            if (currentUrl.includes("classes")) {
                window.location.href =
                    window.location.protocol +
                    "//" +
                    window.location.hostname +
                    "/classes/";
            } else if (currentUrl.includes("journal")) {
                window.location.href =
                    window.location.protocol +
                    "//" +
                    window.location.hostname +
                    "/journal/";
            } else {
                window.location.href =
                    window.location.protocol +
                    "//" +
                    window.location.hostname +
                    window.location.pathname;
            }
        },

        fetchContent(href = null, scroll = true) {
            const postGrid = this.postGrid.querySelector(
                "[data-pegasus-filterable]"
            );
            const elements = [
                'data-pegasus-filterable="' +
                    postGrid.dataset.pegasusFilterable +
                    '"',
            ];

            if (!Object.keys(this.currentFilters).length) {
                if (href) {
                    this.currentUrl = href;
                } else {
                    window.location.href =
                        window.location.protocol +
                        "//" +
                        window.location.hostname +
                        window.location.pathname;
                    return;
                }
            } else {
                this.currentUrl = this.buildUrl();
            }

            if (href) {
                this.currentUrl = href;
            }

            if (!this.isLoading) {
                this.isLoading = true;

                pegasus.ajaxContent(this.currentUrl, elements, {}, () => {
                    this.isLoading = false;
                    history.pushState(
                        JSON.stringify(this.currentFilters),
                        "",
                        this.currentUrl
                    );

                    if (scroll) {
                        pegasus.scroll(this.postGrid);
                    }

                    if (typeof window.modal !== "undefined") {
                        window.modal.init();
                    }
                });
            }
        },

        getCurrentFilters() {
            // Get the current url and parse the query string.
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            let currentFilters = {};

            // Loop through the query string and add each filter to the currentFilters object.
            for (const [key, value] of params.entries()) {
                currentFilters[key] = value;
            }

            return currentFilters;
        },

        filterIsActive(term, filter, type = "taxonomy") {
            const filterName = this.getPrefixedFilter(filter, type);
            const filterValue = this.currentFilters[filterName];

            if (!filterValue) {
                return false;
            }

            const filterValueArray = filterValue.split(",");
            return filterValueArray.includes(term);
        },

        buildUrl() {
            let url =
                window.location.protocol +
                "//" +
                window.location.hostname +
                window.location.pathname +
                "?";
            let i = 1;

            for (const [key, value] of Object.entries(this.currentFilters)) {
                url += `${key}=${value}`;
                if (i < Object.keys(this.currentFilters).length) {
                    url += "&";
                }
                i++;
            }

            return url;
        },

        loadMore() {
            const postGrid = this.$root.querySelector(
                "[data-pegasus-filterable]"
            );
            const dataSelector =
                '[data-pegasus-filterable="' +
                postGrid.dataset.pegasusFilterable +
                '"]';

            const href = this.$el.getAttribute("href");
            const container = [dataSelector];
            const elements = [
                "[data-pegasus-single-card]",
                ".Post__Grid-next-page",
            ];

            if (!this.isLoading) {
                this.isLoading = true;

                pegasus.loadMoreContent(href, container, elements, {}, () => {
                    this.isLoading = false;
                    this.$el.parentElement.remove();

                    // Reinitialize modals after new content is added
                    if (typeof window.modal !== "undefined") {
                        window.modal.init(); // Ensure that this runs after content is added
                    }
                });
            }
        },

        fetchPage(href = null) {
            const postGrid = this.$root.querySelector(
                "[data-pegasus-filterable]"
            );
            const elements = [
                'data-pegasus-filterable="' +
                    postGrid.dataset.pegasusFilterable +
                    '"',
            ];

            if (!this.isLoading) {
                this.isLoading = true;

                pegasus.ajaxContent(href, elements, {}, () => {
                    this.isLoading = false;
                    history.pushState("", "", href);
                    pegasus.scroll(postGrid);

                    if (typeof window.modal !== "undefined") {
                        window.modal.init();
                    }
                });
            }
        },

        getPrefixedFilter(filter, type = "taxonomy") {
            return `${this.filterPrefix[type]}${filter}`;
        },
    }));
});

document.addEventListener("alpine:init", () => {
    Alpine.data("singlePostCard", () => ({
        isHovered: false,
    }));
});
